module.exports = __webpack_public_path__ + "static/img/layer1.bd7d2537.png";